import type { AvailableToolType, ToolCategory } from '@mai/types';
import { AVAILABLE_AGENT_TOOLS } from '@mai/types';

export const categories: ToolCategory[] = [
  'utilities',
  'resources',
  'analysis',
  'search',
  'writing',
];

export const categoryLabels: Record<ToolCategory, string> = {
  utilities: '🔧 Utilities',
  resources: '📁 Resources',
  analysis: '📊 Analysis',
  search: '🔍 Search',
  writing: '✍️ Writing',
};

export const filterToolsBySearch = (searchTerm: string) => {
  const filtered: Record<
    ToolCategory,
    ((typeof AVAILABLE_AGENT_TOOLS)[AvailableToolType] & {
      type: AvailableToolType;
    })[]
  > = {
    utilities: [],
    resources: [],
    analysis: [],
    search: [],
    writing: [],
  };

  Object.entries(AVAILABLE_AGENT_TOOLS).forEach(([type, tool]) => {
    if (
      !searchTerm ||
      tool.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tool.description.toLowerCase().includes(searchTerm.toLowerCase())
    ) {
      filtered[tool.category].push({
        ...tool,
        type: type as AvailableToolType,
      });
    }
  });

  return filtered;
};

export const getCategorySelectionState = (
  tools: ((typeof AVAILABLE_AGENT_TOOLS)[AvailableToolType] & {
    type: AvailableToolType;
  })[],
  selectedTools: Set<AvailableToolType>,
) => {
  const categorySelectedCount = tools.filter((tool) =>
    selectedTools.has(tool.type),
  ).length;

  return {
    categorySelectedCount,
    allSelected: categorySelectedCount === tools.length && tools.length > 0,
    someSelected:
      categorySelectedCount > 0 && categorySelectedCount < tools.length,
  };
};
